import { Component, OnInit, OnDestroy, Renderer2 } from '@angular/core';
import { HeaderComponent } from '../../common/header/header.component';
import { SidebarComponent } from '../../common/slidebar/sidebar.components';

@Component({
  selector: 'app-privacy-policy',
  imports: [HeaderComponent, SidebarComponent],
  templateUrl: './privacy-policy.component.html',
  styleUrl: './privacy-policy.component.css',
})
export class PrivacyPolicyComponent implements OnInit, OnDestroy {
  constructor(private renderer: Renderer2) { }

  ngOnInit() {
    this.renderer.addClass(document.body, 'privacy-policy-page');
  }

  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'privacy-policy-page');
  }
}
